import Vue from 'vue'

export async function copyText(text, opt = {}) {
  const value = String(text || '').trim()
  if (!value) return false
  const label = opt.label || '内容'
  const message = opt.message || Vue.prototype.$message
  try {
    if (navigator && navigator.clipboard && navigator.clipboard.writeText) {
      await navigator.clipboard.writeText(value)
    } else {
      const textarea = document.createElement('textarea')
      textarea.value = value
      textarea.setAttribute('readonly', 'readonly')
      textarea.style.position = 'fixed'
      textarea.style.left = '-9999px'
      textarea.style.top = '-9999px'
      document.body.appendChild(textarea)
      textarea.select()
      document.execCommand('copy')
      document.body.removeChild(textarea)
    }
    if (message && typeof message.success === 'function') {
      message.success(`${label}已复制`)
    } else if (typeof message === 'function') {
      message({ message: `${label}已复制`, type: 'success' })
    }
    return true
  } catch (e) {
    if (message && typeof message.warning === 'function') {
      message.warning('复制失败，请手动复制')
    } else if (typeof message === 'function') {
      message({ message: '复制失败，请手动复制', type: 'warning' })
    }
    return false
  }
}
